/**
 * Coin bas-droite partagé avec le chat (Karim 2026-10-17).
 *
 * Le chat (PublicChatWidget, monté une seule fois pour tout le site dans
 * app.vue) occupe le coin bas-droite. Une page qui y fixe son propre bouton —
 * le panier flottant de la fiche produit — se faisait recouvrir par la
 * mascotte. L'élément flottant déclare la hauteur qu'il occupe ; le chat se
 * pose au-dessus, et redescend dès que l'élément est démonté.
 *
 * `useState` : état partagé réactif entre la page et le widget global, sans
 * prop à faire remonter (même principe que useChatPageContext).
 */
import { onBeforeUnmount, onMounted } from "vue";

const CLE_ETAT = "donoor_chat_decalage_bas";

/** Côté widget : longueur CSS à ajouter sous la bulle (null = aucune). */
export function useChatDecalageBas() {
  return useState<string | null>(CLE_ETAT, () => null);
}

/**
 * Côté élément flottant : réserve `hauteur` (longueur CSS, écart avec la
 * bulle compris) au bas du coin, tant que le composant appelant est monté.
 * Lié au montage et non à une condition recopiée : le chat suit exactement
 * l'affichage réel de l'élément.
 */
export function useReserverCoinChat(hauteur: string) {
  const decalage = useChatDecalageBas();
  onMounted(() => {
    decalage.value = hauteur;
  });
  onBeforeUnmount(() => {
    decalage.value = null;
  });
}
